<div class="row" *ngIf="err_msg">
  <div class="col">
    <div class="alert" [ngClass]="err_msg.alert_class">
      <span class="d-flex justify-content-center">{{ text_msg }}</span>
    </div>
  </div>
</div>
